import { combineReducers } from "redux";
import { cart } from "./Reducers/Cart.reducer";
import { quickSearch } from "./Reducers/QuickSearch.reducer";
import { navigation } from "./Reducers/Navigation.reducer";
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from "./Reducers/MyPage.reducer";
import { checkout } from "./Reducers/Checkout.reducer";
import { notification } from "./Reducers/Notification.reducer";
import { modal } from "./Reducers/Modal.reducer";
import { favouritesdata } from "./Reducers/Favourites.reducer";
import { productConfigurator } from "./Reducers/ProductConfigurator.reducer";
import { savedCart } from "./Reducers/savedCart.reducer";
import { articleStock } from "./Reducers/StockConfig.reducer";
import { googlemap } from "./Reducers/GoogleMap.reducer";
import { savecartpopup } from "./Reducers/SaveCartPopup.reducer";
import { CustomizedMessage } from "./Reducers/CustomizedMessage.reducer";
import { StickyToster } from "./Reducers/StickyToster.reducer";
import { resetPasswordPopup } from "./Reducers/resetPasswordPopup.reducer";
import { organizationList } from "./Reducers/OrganizationList.reducer";
import { clearallcartpopup } from "./Reducers/ClearAllCartPopup.reducer";


const app = combineReducers({
  cart,
  checkout,
  quickSearch,
  navigation,
  myPage,
  facetedSearch,
  notification,
  modal,
  favouritesdata,
  productConfigurator,
  savedCart,
  articleStock,
  googlemap,
  savecartpopup,
  CustomizedMessage,
  StickyToster,
  resetPasswordPopup,
  organizationList,
  clearallcartpopup,
});

export default app;
